import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .action {
      position: relative;
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
      .btn1 {
         margin-top: 3px;
            
         .line {
            margin-bottom: 0;
            &::after { display: none; }
         }
      }
      .download { margin-left: 7.5px; }
   }
   .select {
      margin-top: 10px;
      &:first-of-type { margin-top: 0; }
      h4 { min-width: 75px; }
      > div { min-width: 228.27px }
   }
   .textInput {
      margin-top: 10px;
      h4 { width: 125px; }
   }
   > .scroll {
      overflow: auto;
      max-height: 150px;
      padding-right: 10px;
      margin-top: 10px;
   }
   .headers {
      margin-top: 10px;
   }
   .filesEdit {
      top: 48px !important;
      right: calc(100% + 22px) !important;

      &.events {
         width: auto !important;

         .checkbox > div label {
            width: auto !important;
         }
      }
      &.fields {
         width: 250px !important;
         height: auto !important;
         max-height: 200px;

         .checkbox {
            height: auto !important;
            max-height: 186px;

            > div label {
               width: calc(240px - 17px - 10px - 15px) !important;
            }
         }
      }
   }
`;